(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/payment-middlewares/assets/middleware-transfer-rows/transfer-rows-setup.js') >= 0) return;  svs.modules.push('/components/tipsen/payment-middlewares/assets/middleware-transfer-rows/transfer-rows-setup.js');
"use strict";

const dialog = svs.components.dialog;
const Confirm = dialog.Confirm,
  branding = dialog.branding,
  type = dialog.type;
const _svs$components$payme = svs.components.payment.middleware.transferRows,
  transferRows = _svs$components$payme.transferRows,
  transferUtils = _svs$components$payme.utils;
const transferRowsMW = gameUrlOptions => transferRows(transferContext => new Promise(resolve => {
  const transferUrl = transferContext.transferUrl,
    title = transferContext.title,
    onCallback = transferContext.onCallback;
  const dialogConfig = {
    branding: branding.SPORT,
    type: type.DEFAULT,
    icon: 'nav-my-games',
    title,
    actions: [{
      title: 'Nej tack',
      showLoader: true,
      callback() {
        onCallback(transferUtils.TRACKING_ACTIONS.CANCEL_TRANSFER);
        dialog.api.close();
        resolve();
      }
    }, {
      title: 'Överför',
      showLoader: true,
      callback() {
        onCallback(transferUtils.TRACKING_ACTIONS.TRANSFER);
        location.href = transferUrl;
        dialog.api.close();
        resolve();
      }
    }]
  };
  dialog.api.add(new Confirm(dialogConfig));
}), {
  gameUrlOptions
});
setGlobal('svs.components.paymentMiddlewares.middlewareTransferRows.transferRowsMW', transferRowsMW);

 })(window);